import React from 'react';
import { motion } from 'framer-motion';
import '../styles/WhyChooseUs.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      id: 'wcs-expertise',
      icon: '🚀',
      title: 'Expert Team',
      description: 'Our skilled developers and marketers bring years of industry experience to every project.'
    },
    {
      id: 'wcs-innovation',
      icon: '💡',
      title: 'Innovative Solutions',
      description: 'We use cutting-edge technologies and creative strategies to deliver exceptional results.'
    },
    {
      id: 'wcs-support',
      icon: '🛡️',
      title: '24/7 Support',
      description: 'Round-the-clock support ensures your business never stops growing.'
    },
    {
      id: 'wcs-results',
      icon: '📈',
      title: 'Proven Results',
      description: 'Track record of successful projects and satisfied clients across various industries.'
    },
    {
      id: 'wcs-custom',
      icon: '⚙️',
      title: 'Custom Approach',
      description: 'Tailored solutions designed specifically for your business needs and goals.'
    },
    {
      id: 'wcs-value',
      icon: '💎',
      title: 'Best Value',
      description: 'Premium quality services at competitive prices with transparent billing.'
    }
  ];


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8
      }
    }
  };

  const headerVariants = {
    hidden: { y: -30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="wcs-container" id="wcs-why-choose-us">
      <motion.div 
        className="wcs-content"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="wcs-header" variants={headerVariants}>
          <h2 className="wcs-title">Why Choose Us</h2>
          <p className="wcs-subtitle">
            Discover what makes QuantumFrame Studio the preferred choice for businesses 
            looking to excel in the digital landscape.
          </p>
        </motion.div>

        {/* Desktop Grid Layout */}
        <motion.div 
          className="wcs-grid"
          variants={containerVariants}
        >
          {reasons.map((reason, index) => (
            <motion.div
              key={reason.id}
              className="wcs-card"
              initial={{ y: 50, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ 
                delay: index * 0.1,
                duration: 0.6,
                ease: "easeOut"
              }}
              whileHover={{ 
                y: -10,
                scale: 1.02,
                transition: { duration: 0.3 }
              }}
            >
              <div className="wcs-card-content">
                <div className="wcs-icon">
                  <span className="wcs-icon-symbol">{reason.icon}</span>
                </div>
                <div className="wcs-text-content">
                  <h3 className="wcs-card-title">{reason.title}</h3>
                  <p className="wcs-card-description">{reason.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Mobile Carousel Layout */}
        <motion.div 
          className="wcs-slider-container"
          variants={containerVariants}
        >
          <div className="wcs-slider-wrapper">
            <div className="wcs-slider">
              {/* First set of reasons */}
              {reasons.map((reason) => (
                <motion.div
                  key={`first-${reason.id}`}
                  className="wcs-card"
                  whileHover={{ 
                    scale: 1.05,
                    transition: { duration: 0.3 }
                  }}
                >
                  <div className="wcs-card-content">
                    <div className="wcs-icon">
                      <span className="wcs-icon-symbol">{reason.icon}</span>
                    </div>
                    <div className="wcs-text-content">
                      <h3 className="wcs-card-title">{reason.title}</h3>
                      <p className="wcs-card-description">{reason.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}

              {/* Second set of reasons for seamless loop */}
              {reasons.map((reason) => (
                <motion.div
                  key={`second-${reason.id}`}
                  className="wcs-card"
                  whileHover={{ 
                    scale: 1.05,
                    transition: { duration: 0.3 }
                  }}
                >
                  <div className="wcs-card-content">
                    <div className="wcs-icon">
                      <span className="wcs-icon-symbol">{reason.icon}</span>
                    </div>
                    <div className="wcs-text-content">
                      <h3 className="wcs-card-title">{reason.title}</h3>
                      <p className="wcs-card-description">{reason.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default WhyChooseUs;
